import { useLocationAutocomplete } from "../hooks/use-location-autocomplete.js";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Autocomplete, IconLocationOn } from "@myphx-engineering/phx-design-system";
import { jsx } from "react/jsx-runtime";

//#region src/components/LocationPicker.tsx
const LocationPicker = ({ geolocation, onLocationChange, locationService, requireFullAddress, placeholder, autofill = true, setError, onFocus, rightSectionWidth, secondaryRightSection, onSuggestionsChange }) => {
	const { t } = useTranslation("loc");
	const { textValue, dataItems, options, errorMessage, isMyLocationLoading, handleInputChange, handleBlur, handleOptionSubmit } = useLocationAutocomplete({
		geolocation,
		onLocationChange,
		locationService,
		requireFullAddress,
		setError,
		autofill
	});
	useEffect(() => {
		onSuggestionsChange?.(options);
	}, [onSuggestionsChange, options]);
	return /* @__PURE__ */ jsx(Autocomplete, {
		disabled: isMyLocationLoading,
		placeholder: t("locationPicker.placeholder"),
		filter: ({ options: options$1 }) => options$1,
		onChange: (geolocation$1) => {
			if (typeof geolocation$1 === "string") handleInputChange(geolocation$1);
			if (geolocation$1 && typeof geolocation$1 !== "string") onLocationChange(geolocation$1);
		},
		label: placeholder ?? t("locationPicker.label"),
		error: setError ? !!errorMessage : errorMessage,
		optionIcon: /* @__PURE__ */ jsx(IconLocationOn, { color: "primary" }),
		defaultValue: geolocation?.name,
		onOptionSubmit: handleOptionSubmit,
		data: onSuggestionsChange ? [] : dataItems,
		value: textValue,
		onBlur: handleBlur,
		onFocus,
		rightSectionWidth,
		secondaryRightSection,
		withErrorStyles: !setError
	});
};

//#endregion
export { LocationPicker };